import { gatewaySectorWorkFlows } from "../../../../../../../../gateways/gatewaySectorWorkFlows";

export const getCategories = async () => {
  const res = await gatewaySectorWorkFlows.get(`/categories`);
  return res.data?.data || res.data;
};
